// extracted by mini-css-extract-plugin
module.exports = {"delay":"Delay_delay__130PK"};